import React from "react";

import SrrRowBase from "./SrrRowBase";

const ReportReturnCarServiceByDealer = ({ row, items, group }) => {
  const dealerArr = ["DealerName", "INN", "ent_id", "subject", "FO", "city"];
  const cityArr = ["city", "subject", "FO"];
  const foArr = ["FO"];
  const regionArr = ["subject", "FO"];
  let optionsTable = [];

  switch (group["group"]) {
    case "dealer":
      optionsTable = dealerArr.map((el) => row[el]);
      break;
    case "city":
      optionsTable = cityArr.map((el) => row[el]);

      break;
    case "fo":
      optionsTable = foArr.map((el) => row[el]);

      break;
    case "region":
      optionsTable = regionArr.map((el) => row[el]);
      break;
  }

  const renderItem = [
    ...row?.periods?.map((period) => {
      const arrTO = [];
      (group.arrTO || []).map((to) => {
        arrTO.push(period.TO[to]);
      });

      return [...arrTO, period.TO.AllTO, period.TO.Warranty, period.TO.writ];
    }),
  ];

  return <SrrRowBase leadingCells={optionsTable} cells={renderItem} />;
};

export default ReportReturnCarServiceByDealer;
